import { Checkbox, ListItemText } from "@mui/material";
import { KeyboardEvent } from "react";
import { BaseSelectMenuItem } from "~/components/Form/components/SelectMenu/BaseSelectMenu/BaseSelectMenuItem";

export type CheckboxMenuItemProps = {
  label: string;
  value: string;
  isChecked: boolean;
  onClick?: (value: string) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLLIElement>, label: string) => void;
  disabled?: boolean;
};

export const CheckboxSelectMenuItem = ({
  label,
  value,
  isChecked,
  onClick,
  onKeyDown,
  disabled,
}: CheckboxMenuItemProps) => {
  return (
    <BaseSelectMenuItem
      label={label}
      value={value}
      onClick={onClick}
      onKeyDown={onKeyDown}
      disabled={disabled}
      sx={{
        "&.MuiMenuItem-root": {
          p: 0.5,
          my: 1,
        },
      }}
    >
      <Checkbox
        checked={isChecked}
        disabled={disabled}
        disableRipple
        sx={{
          "&.MuiCheckbox-root": {
            p: 0,
            px: 0.5,
          },
        }}
      />
      <ListItemText primary={label} sx={{ ml: 1 }} />
    </BaseSelectMenuItem>
  );
};
